import { Logger } from '~/shared/logger'

/**
 * Process-level logger for initialization/wiring issues.
 */
export const logger = new Logger('tria/processes/analytix')
